import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';
import { InputSize } from '@shared/types/common/input';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'nowrap',

      '&:hover $closeIconContainer': {
        display: 'flex',
      },
    },
    rootWithContainer: {
      backgroundColor: colours.solid.white,
      border: `1px solid ${colours.neutral[300]}`,
      borderRadius: 6,
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.07)',

      '&:hover': {
        border: `1px solid ${colours.neutral[400]}`,
        boxShadow: '0px 4px 8px -2px rgba(16, 24, 40, 0.05), 0px 2px 4px -1px rgba(16, 24, 40, 0.10)',
      },
    },
    [InputSize.small]: {
      height: 32,

      '&$rootWithContainer': {
        padding: spacing(2),
      },
      '& $content': {
        gap: spacing(2),
      },
      '& $textContainer': {
        gap: spacing(0),
      },
      '& $dragIcon': {
        fontSize: 14,
      },
      '& $closeIconContainer': {
        padding: spacing(0.5),
      },
    },
    [InputSize.mediumLegacy]: {
      height: 36,

      '&$rootWithContainer': {
        padding: spacing(2),
      },
      '& $content': {
        gap: spacing(2),
      },
      '& $textContainer': {
        gap: spacing(0),
      },
      '& $dragIcon': {
        fontSize: 14,
      },
      '& $closeIconContainer': {
        padding: spacing(1),
      },
    },
    [InputSize.medium]: {
      height: 40,

      '&$rootWithContainer': {
        padding: spacing(2),
      },
      '& $content': {
        gap: spacing(2),
      },
      '& $textContainer': {
        gap: spacing(0.5),
      },
      '& $dragIcon': {
        fontSize: 14,
      },
      '& $closeIconContainer': {
        padding: spacing(1.5),
      },
    },
    [InputSize.large]: {
      height: 48,

      '&$rootWithContainer': {
        padding: spacing(2),
      },
      '& $content': {
        gap: spacing(2),
      },
      '& $textContainer': {
        gap: spacing(1),
      },
      '& $dragIcon': {
        fontSize: 14,
      },
      '& $closeIconContainer': {
        padding: spacing(2),
      },
    },

    content: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      userSelect: 'none',
      width: '100%',
    },
    contentClickable: {
      cursor: 'pointer',
    },
    dragIcon: {
      fontSize: 'inherit',
    },
    avatar: {
      flex: '0 0 auto',
    },
    newBadge: {
      backgroundColor: '#ECFDF3', //TODO replace after new palette creating
      flex: '0 0 auto',
    },
    textContainer: {
      display: 'flex',
      flex: '1 1 auto',
      flexDirection: 'column',
      overflow: 'auto',
      userSelect: 'none',
    },
    text: {
      color: '#344054', //TODO replace after creating new palette
      fontWeight: 500,
      lineHeight: 1.15,
    },
    subText: {
      color: '#7E8899', //TODO replace after creating new palette
      fontWeight: 400,
      lineHeight: 1.15,
    },

    closeIconContainer: {
      borderRadius: 6,
      cursor: 'pointer',
      display: 'none',
      flex: '0 0 auto',

      '&:hover': {
        backgroundColor: colours.neutral[100],
      },
    },
    closeIcon: {
      fontSize: 14,
    },
  });
